import './polyfill';
import { AppRoot } from 'AppRoot';
import CONFIGURABLE_CONSTANTS from 'constants/configurable.constants';
import { render } from 'preact/compat';
import { setPTPInitData } from 'services/sentry.services';

const isDevelopment = process.env.NODE_ENV === 'development';

if (isDevelopment) {
  // eslint-disable-next-line global-require
  require('preact/debug');
}

// eslint-disable-next-line
__webpack_public_path__ = !isDevelopment
  ? CONFIGURABLE_CONSTANTS.publicURL
  : '/';

function renderAppRoot(appRootElement: Element) {
  if (appRootElement.getAttribute('data-initialized') === 'true') {
    console.warn('[PTP]: initialized PTP widget');
    return;
  }

  setPTPInitData();
  appRootElement.setAttribute('data-initialized', 'true');

  const cmsSlug = appRootElement.getAttribute('data-cms-slug');
  if (!cmsSlug) {
    console.error('[PTP]: data-cms-slug is not provided');
    return;
  }

  render(<AppRoot cmsSlug={cmsSlug} />, appRootElement);
}

function initPtpWidget() {
  let rootElement = document.getElementById('pp-widget-root');

  if (!rootElement) {
    const observeTimeout = 10000;
    let timer;

    console.warn('[PTP]: waiting for pp-widget-root element');

    const callBack = (_, observer) => {
      rootElement = document.getElementById('pp-widget-root');
      if (rootElement) {
        observer.disconnect();
        if (timer) clearTimeout(timer);
        renderAppRoot(rootElement);
      }
    };

    const observer = new MutationObserver(callBack);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Destroy observer when nothing found.
    timer = setTimeout(() => {
      observer.disconnect();
      console.warn('[PTP]: can not find pp-widget-root element');
    }, observeTimeout);
  } else {
    renderAppRoot(rootElement);
  }
}

initPtpWidget();
